import { render, staticRenderFns } from "./energy.vue?vue&type=template&id=70e0aab0&scoped=true&"
import script from "./energy.vue?vue&type=script&lang=js&"
export * from "./energy.vue?vue&type=script&lang=js&"
import style0 from "./energy.vue?vue&type=style&index=0&id=70e0aab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e0aab0",
  null
  
)

export default component.exports